var foldFormDataToRequest = function foldFormDataToRequest(formdata, request) {
  request.body = formdata;
};

export default foldFormDataToRequest;


//////////////////
// WEBPACK FOOTER
// ./node_modules/swagger-client/es/http/fold-formdata-to-request.browser.js
// module id = null
// module chunks = 